/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { GetCategoryAction, GetCategoryActionType, GetCategoryState } from './types';

export const initialGetCategoryState: GetCategoryState = {
  loading: false,
  error: null,
  category: null,
};

export default function getCategoryReducer(
  state = initialGetCategoryState,
  action: GetCategoryAction,
): GetCategoryState {
  switch (action.type) {
    case GetCategoryActionType.GET_CATEGORY:
      return update(state, {
        loading: { $set: true },
        error: { $set: null },
      });
    case GetCategoryActionType.GET_CATEGORY_SUCCESS:
      return update(state, {
        loading: { $set: false },
        category: { $set: action.category },
      });
    case GetCategoryActionType.GET_CATEGORY_ERROR:
      return update(state, {
        loading: { $set: false },
        error: { $set: action.error },
      });
    default:
      return state;
  }
}
